// Translations in Italian for User Manager UI
export default {
  nav: {
    title: 'Gestione Utenti',
    users: 'Utenti',
    roles: 'Ruoli',
    permissions: 'Permessi',
  },
  actions: {
    editUser: 'Modifica Utente',
    deleteUser: 'Elimina Utente',
    createUser: 'Crea Utente',
    manageRoles: 'Gestisci Ruoli',
    editRole: 'Modifica Ruolo',
    createRole: 'Crea Ruolo',
    managePermissions: 'Gestisci Permessi',
    editPermission: 'Modifica Permesso',
    createPermission: 'Crea Permesso',
  },
  notifications: {
    userDeleted: 'Utente eliminato con successo',
  }
}
